import Logo from "./logoez.webp"
import download from "./icond.png"
import fevicon from "./favicon.webp"
export const images={
    Logo,download,fevicon
}